import React from 'react';

import useStyles from './styles';

import { CpeMatchItem, Operator } from '../../types';
import CpeMatch from '../CpeMatch';
import OperatorTag from '../OperatorTag';

interface Props {
    operator: Operator;
    data: CpeMatchItem[];
    className?: string;
}

const Node: React.FC<Props> = ({ operator, data, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.line} />
            <div className={classes.items}>
                {data.map((item, index) => (
                    <React.Fragment key={index}>
                        {index === 0 ? null : (
                            <OperatorTag label={operator} className={classes.operator} color="blue" />
                        )}
                        <CpeMatch key={index} data={item} className={classes.item} />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Node;
